<template lang="pug">
#betslip-parlay.modal.modal-bottom.fade.modal-betslip(tabindex='-1' role='dialog' aria-labelledby='betslip-parlay' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="!isDataExists")
          .bet-slip
            .bet-slip-wrapper
              .stake-info-wrapper
                .close(@click="hideMe()")
                  i.fal.fa-times
                span {{ $t("ui.no_bet") }}
                .stake-info
                  .betslip-match.text-left(v-if="!loading.check") {{ $t("message.bet_empty") }}
                  .betslip-match(v-else)
                    i.fad.fa-spinner.fa-spin
        template(v-else)
          .bet-slip.bet-slip-parlay
            .parlay-slip-header
              .title {{ $t("ui.parlay_slip") }}
              .remove-all(@click="handleCloseAll()") {{ $t("ui.remove_all") }}
            template(v-for="(item, index) in betparlay")
              .bet-slip-wrapper
                .stake-info-wrapper
                  .bet-type-parlay(:id="'betslip-parlay-' + item.matchId")
                    .close(@click="handleCloseBet(item.matchId)")
                      i.fal.fa-times
                    .bet-league
                      img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(item.sportsType)")
                      span [{{ index+1 }}] {{ sports[item.sportsType] }} - {{ $t("m.BS_" + item.betType) }}
                  .stake-info
                    .betslip-match
                      .team-involved
                        .score(v-if="item.marketType == 3 && item.score != ''") {{ item.score }}
                        span(:class="item.giving == 1 && isBallDisplay(item) ? 'team2' : 'team1'") {{ item.homeName }}
                        span.vs(v-if="item.betType != 'OR'") - VS -
                        span(:class="item.giving == 0 && isBallDisplay(item) ? 'team2' : 'team1'" v-if="item.betType != 'OR'") {{ item.awayName }}
                    .selector-odd.d-flex.justify-content-between
                      span.text(:class="isBallDisplay(item) == false ? '' : ((item.giving == 0 && item.homeAway == 2) ? 'team2' : (item.giving == 1 && item.homeAway == 1) ? 'team2' : 'team1')") {{ item.betType }} | {{ item.betDisplay }}
                      .bet-type-odds
                        span.bet-type-text {{ ballDisplay(item) }}
                        .odds
                          span(:class="{ 'negetive' : item.val < 0 }") {{ item.val }}
                .odds-change-notice(v-if="oddsIsUpdating || invalidOdds")
                  i.fal.fa-exclamation-circle.text-warning.mr-1
                  span {{ $t("error.oddsIsUpdating") }}
                .odds-change-notice(v-if="errorMessage")
                  i.fal.fa-exclamation-circle.text-danger.mr-1
                  span {{ errorMessage }}
            .footer-slip.text-left
              .d-flex.parlay-group-wrapper
                #parlay-system.dropdown.btn-parlay-group
                  .btn-parlay-system.dropdown-btn(@click="expand($event)") {{ fold }} {{$t("ui.fold") }} ({{ total_bet }} {{ $t("ui.bets") }})
                  ul.parlay-system-menu
                    template(v-for="mc in comboKeys")
                      li.dropdown-item
                        a(href="javascript:void(0)" @click="setFold(mc)") {{ mc }} {{ $t("ui.fold") }} ({{ comboIndex[mc] }} {{ $t("ui.bets") }})
                .btn-add-selection(@click="hideMe()") {{ $t("ui.add_more_selection") }}
              .payout-wrapper.pb-0
                .left {{ $t("ui.odds") }}: {{ $numeral(multi).format("0,0.00[0]") }}
                .right {{ $t("ui.total_stake") }}: {{ $numeral(total_stake).format("0,0.00[0]") }}
              .payout-wrapper.pt-0
                .left {{ $t("ui.min") }}: {{ $numeral(minBet).format("0,0") }} | {{ $t("ui.max") }}: {{ $numeral(maxBet).format("0,0") }}
                .right {{ $t("ui.payout") }}: {{ $numeral(payout).format("0,0.00[0]") }}
              template(v-if="betparlayCount")
                .stake-wrapper
                  .d-flex.justify-content-between.flex-fill.mr-1.bet-input
                    .d-flex.align-items-center.flex-fill.mr-1.stake-input-wrapper
                      .text-secondary.stake-decrement.pl-2.pr-2(@click="decreaseStake")
                        i.fas.fa-minus-circle
                      .stake-mask.flex-fill(@click="maskStake")
                        StakeInput(v-model="stake" @handleStake="handleStake" ref="stake" :loadbet="loading.check")
                      .text-secondary.stake-increment.pl-2.pr-2(@click="increaseStake")
                        i.fas.fa-plus-circle
                      .text-secondary.stake-cancel.pl-2.pr-2(@click="clearStake")
                        i.fas.fa-times-circle
                  #place-bet.place-bet
                    SpinButton(css="btn-warning btn-sm rounded-0 text-center text-uppercase" @click="bet()" :text="$t('ui.process_bet')" :loading="loading.process")
                .keyboard                  
                  .pt-2.pl-2.pr-2.pb-1.cluster
                    .row.mx-0
                      .col-2.px-0.text-center.button-tap(@click="keyStake('1')")
                        span 1
                      .col-2.px-0.text-center.button-tap(@click="keyStake('2')")
                        span 2
                      .col-2.px-0.text-center.button-tap(@click="keyStake('3')")
                        span 3
                      .col-2.px-0.text-center.button-tap(@click="keyStake('4')")
                        span 4
                      .col-2.px-0.text-center.button-tap(@click="keyStake('5')")
                        span 5
                      .col-2.px-0.text-center.button-tap.special.pt-2.del(@click="deleteStake()")
                        span DEL
                        br
                        i.fas.fa-long-arrow-alt-left
                    .row.mx-0
                      .col-2.px-0.text-center.button-tap(@click="keyStake('6')")
                        span 6
                      .col-2.px-0.text-center.button-tap(@click="keyStake('7')")
                        span 7
                      .col-2.px-0.text-center.button-tap(@click="keyStake('8')")
                        span 8
                      .col-2.px-0.text-center.button-tap(@click="keyStake('9')")
                        span 9
                      .col-2.px-0.text-center.button-tap(@click="keyStake('0')")
                        span 0
                      .col-2.px-0.text-center.button-tap.special.pt-3.text-dark.done(@click="doneStake()")
                        span DONE
                  .pt-2.pl-2.pr-2.pb-0
                    .row.mx-0
                      .col-3.px-0.text-center.add-stake(@click="fastStake(20)")
                        span + 20
                      .col-3.px-0.text-center.add-stake(@click="fastStake(50)")
                        span + 50
                      .col-3.px-0.text-center.add-stake(@click="fastStake(100)")
                        span + 100
                      .col-3.px-0.text-center.add-stake.btn-max(@click="maxStake")
                        span {{ $t("ui.max") }}
                .bet-infosub
                  .checkbox
                    label.d-flex(@click="handleAcceptAnyOdds")
                      input(type="checkbox" :checked="betting.acceptAnyOdds == 'true'")
                      span.label(@click="handleAcceptAnyOdds") {{ $t("ui.accept_any_odds") }}
                  .checkbox
                    label.d-flex(@click="handleRememberStake")
                      input(type="checkbox" :checked="betting.defaultStake == '0'")
                      span.label(@click="handleRememberStake") {{ $t("ui.remember_stake") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhrBet from "@/library/_xhr-bet.js";
import calc from "@/library/_calculation.js";
import config from "@/config";
import StakeInput from "@/components/mobile/bets/new/stakeInput";
import SpinButton from "@/components/ui/SpinButton";
import mixinBetType from "@/library/mixinBetType";
import mixinDelay from "@/library/mixinDelay";
import naming from "@/library/_name";

export default {
  components: {
    SpinButton,
    StakeInput
  },
  mixins: [mixinBetType, mixinDelay],
  data() {
    return {
      errorMessage: "",
      debounceBet: null,
      loading: {
        check: false,
        cancel: false,
        process: false
      },
      league: {},
      match: {},
      child: {},
      defaultCounter: 10,
      counter: 10,
      placeSlip: {},
      stake: null,
      total_bet: 1,
      total_stake: 0,
      fold: 0,
      payout: null,
      invalidOdds: false,
      oddsIsUpdating: false,
      autoCloseOddsIsUpdating: null,
      parlayMatch: {},
      betConfirm: false,
      isMMO: false
    };
  },
  computed: {
    combo() {
      return this.$store.state.betparlay.combo;
    },
    comboKeys() {
      return Object.keys(this.$store.state.betparlay.combo);
    },
    comboIndex() {
      var results = {};
      for (var n in this.comboKeys) {
        results[this.comboKeys[n]] = this.combo[this.comboKeys[n]].length;
      }

      return results;
    },
    comboOdds() {
      var results = {};
      // var nn = 0;
      for (var n in this.comboKeys) {
        for (var m in this.combo[this.comboKeys[n]]) {
          // nn = nn + 1;
          if (results[this.comboKeys[n]] == null) {
            results[this.comboKeys[n]] = [];
          }
          var multi = 1.0;
          var po = -1;
          for (var j in this.combo[this.comboKeys[n]][m]) {
            var test = this.$store.state.betparlay.data[this.combo[this.comboKeys[n]][m][j]];
            if (test != null) {
              multi = multi * parseFloat(test.val);
              var mpo = test.maxParlayPayout;
              if (po < 0 || po > mpo) po = mpo;
            }
          }

          results[this.comboKeys[n]].push([multi, po]);
        }
      }
      return results;
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    commType() {
      return this.$store.getters.commType;
    },
    multi() {
      var result = 0.0;
      if (this.comboOdds.hasOwnProperty(this.fold)) {
        for (var n in this.comboOdds[this.fold]) {
          result = result + this.comboOdds[this.fold][n][0];
        }
      }

      var f = parseFloat(calc.fm(result, false, 4)).toFixed(3);
      return f;
    },
    MPP() {
      var result = 0;
      var mm = null;
      if (this.comboOdds.hasOwnProperty(this.fold)) {
        for (var n in this.comboOdds[this.fold]) {
          var j = this.comboOdds[this.fold][n][1] / this.comboOdds[this.fold][n][0];
          if (mm == null) {
            mm = j;
            result = j;
          } else {
            if (j < mm) {
              mm = j;
              result = j;
            }
          }
        }
      }
      return result;
    },
    maxBet() {
      var max = 0;
      var max = calc.truncateInteger(this.MPP);
      for (var n in this.betparlay) {
        if (max > parseFloat(this.betparlay[n].maxBet)) {
          max = parseFloat(this.betparlay[n].maxBet);
        }
      }
      return max;
    },
    minBet() {
      var result = 0;
      for (var n in this.betparlay) {
        if (result == 0) {
          result = this.betparlay[n].minBet;
        } else {
          if (result < this.betparlay[n].minBet) {
            result = this.betparlay[n].minBet;
          }
        }
      }
      return result;
    },
    maxPayout() {
      var result = 0;
      for (var n in this.betparlay) {
        if (result == 0) {
          result = this.betparlay[n].maxPayout;
        } else {
          if (result < this.betparlay[n].maxPayout) {
            result = this.betparlay[n].maxPayout;
          }
        }
      }
      return result;
    },
    maxParlayPayout() {
      var result = 0;
      for (var n in this.betparlay) {
        if (result == 0) {
          result = this.betparlay[n].maxParlayPayout;
        } else {
          if (result > this.betparlay[n].maxParlayPayout) {
            result = this.betparlay[n].maxParlayPayout;
          }
        }
      }
      return result;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    betparlay() {
      var tempOrder = [];
      tempOrder = Object.values(this.$store.state.betparlay.data).sort(function(a, b) {
        return a.bettime < b.bettime ? -1 : a.bettime > b.bettime ? 1 : 0;
      });
      return tempOrder;
    },
    betparlayCount() {
      return Object.keys(this.$store.state.betparlay.data).length >= config.parlayMinTicket;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    isDataExists() {
      if (Object.keys(this.betparlay).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isPlaceBet() {
      var is_live = false;
      for (var n in this.betparlay) {
        if (this.betparlay[n].marketType == 3) {
          is_live = true;
          break;
        }
      }

      if (is_live) {
        if (Object.keys(this.betparlay).length >= config.parlayLiveMinTicket) {
          return true;
        } else {
          return false;
        }
      } else {
        if (Object.keys(this.betparlay).length >= config.parlayMinTicket) {
          return true;
        } else {
          return false;
        }
      }
    },
    matchCount() {
      if (this.betparlay) {
        return Object.keys(this.betparlay).length;
      } else {
        return 0;
      }
    }
  },
  watch: {
    fold(newVal) {
      this.changeTotalBet();
    },
    stake(newVal) {
      this.handlePayout();
    },
    multi(newVal) {
      this.handlePayout();
    },
    matchCount(newVal) {
      this.fold = newVal;
    }
  },
  destroyed() {
    clearInterval(this.autoRefresh);
  },
  mounted() {
    this.debounceBet = this.debounce(this.processBet, 1000);
    setInterval(this.autoRefresh, this.defaultCounter * 1000);
    EventBus.betParlay = this.runbet;
    EventBus.closeParlay = this.handleCloseBet;
    EventBus.showParlay = this.showMe;
    EventBus.cancelParlay = this.handleCloseAll;

    EventBus.addPick = this.addPick;

    this.fold = this.matchCount

    // Hide the dropdown when clicking outside of it
    $(document).on("click", function(event) {
      if (!$(event.target).closest(".btn-parlay-system").length) {
        $(".parlay-system-menu").hide();
      }
    });
  },
  methods: {
    setFold(fold) {
      this.fold = fold;
      $('.parlay-system-menu').hide();
    },
    changeTotalBet() {
      if (this.comboIndex.hasOwnProperty(this.fold)) {
        this.total_bet = this.comboIndex[this.fold];
      } else {
        this.total_bet = 0;
      }
      this.handleStake();
    },
    expand(evt) {
      evt.stopPropagation();
      $('.parlay-system-menu').slideToggle();
    },
    bet() {
      this.loading.process = true;
      this.errorMessage = "";
      this.betConfirm = true;
      if (this.debounceBet) {
        this.debounceBet();
      }
    },
    showMe() {
      this.loading.process = false;
      $("#betslip-parlay").modal("show");
    },
    hideMe() {
      $("#betslip-parlay").modal("hide");
    },
    ballDisplay(e) {
      return naming.ballDisplay2(e.ballDisplay, e.giving, e.homeAway, e.betType, this);
    },
    handleRememberStake() {
      this.$store.dispatch("layout/setSingleBetting", { property: "defaultStake", value: this.betting.defaultStake == "0" ? "3" : "0" });
    },
    isBallDisplay(e) {
      var result = naming.ballDisplay2(e.ballDisplay, e.giving, e.homeAway, e.betType, this);
      if (["HDP", "HDPH"].includes(e.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    existsInSlip(odds) {
      return Object.keys(this.$store.state.betparlay.data).includes(odds[1].toString());
    },
    runbet(odds, typ, idx, val, bt, amt, isMMO, e, pos, giving) {
      if (isMMO) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.invalidCurrency"), "error");
        return;
      }

      if (!this.existsInSlip(odds)) {
        if (Object.keys(this.$store.state.betparlay.data).length + 1 > config.parlayMaxTicket) {
          this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
          return;
        }
      }
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();

      this.isMMO = isMMO;
      this.stake = amt;
      this.calculateStake();
      this.handleStake();
      this.checkParlayBet(odds, typ, idx, val, bt);
      if (this.$refs.stake) {
        this.$refs.stake.focus();
      }
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
    },
    cache() {
      return this.$store.getters.data;
    },
    fastBet() {
      if (this.isPlaceBet) {
        document.onkeyup = null;
        this.handleStake();
        this.$swal({ title: this.$t("ui.confirmation"), text: this.$t("message.confirmation"), type: "info", showCancelButton: true }).then(result => {
          if (result.value) {
            this.bet();
          }
        });
      }
    },
    processConfirmBet() {
      // console.log("processConfirmBet");
      this.errorMessage = "";
      this.betConfirm = true;
      document.onkeyup = event => {
        if (event.which == 13 || event.keyCode == 13) {
          this.bet();
        } else {
          if (event.which == 27 || event.keyCode == 27) {
            this.betConfirm = false;
          }
        }
      };
    },
    handleCloseBet(e) {
      this.$store.dispatch("betparlay/removeData", e).then(() => {
        this.$store.dispatch("betparlay/setCombo").then(() => {
          this.changeTotalBet();
        });
      });
      this.parlayMatch[e] = 0;
    },
    handleCloseAll() {
      this.$store.dispatch("betparlay/clearData");
      this.parlayMatch = {};
      this.hideMe();
    },
    processBet() {
      // console.log("processBet:", this.betConfirm, this.loading)
      if (!this.betConfirm || Object.keys(this.betparlay).length == 0) return;

      this.errorMessage = "";
      this.betConfirm = false;
      this.loading.process = true;
      var old = this.placeSlip;
      var validBet = true;
      this.placeSlip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        bet_member: this.stake,
        accept_any_odds: this.betting.acceptAnyOdds,
        bet_detail: [],
        operator_type: this.$store.getters.operatorType,
        parent_id: this.$store.getters.parentId,
        fold: this.fold,
        bet_total: this.total_stake,
        mode: this.fold == this.matchCount && this.total_bet == 1 && this.total_stake == this.stake
      };

      if (this.stake > this.maxBet) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.betOverMaxBet"), "info");
        this.loading.process = false;
        this.betConfirm = true;
        return;
      }

      var is_live = false;

      for (var n in this.betparlay) {
        var item = {};
        item["a"] = this.betparlay[n].oddsId;
        item["b"] = this.betparlay[n].subMatchId;
        item["c"] = this.betparlay[n].matchId;
        item["d"] = this.betparlay[n].betType;
        item["e"] = this.betparlay[n].betTeamId;
        item["f"] = this.betparlay[n].homeAway;
        item["g"] = parseFloat(this.betparlay[n].val);
        item["h"] = parseFloat(this.betparlay[n].origin);
        item["j"] = this.betparlay[n].ballDisplay;
        if (this.betparlay[n].marketType == 3) {
          is_live = true;
        }
        this.placeSlip.bet_detail.push(item);
        if (this.betparlay[n].betStatus == "false") {
          validBet = false;
        }
      }

      // check the parlay match count before send
      if (is_live) {
        if (this.placeSlip.bet_detail.length < config.parlayLiveMinTicket) {
          this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.atLeastThreeMatchToBetParlay"), "info");
          this.loading.process = false;
          this.betConfirm = true;
          return;
        }
      } else {
        if (this.placeSlip.bet_detail.length < config.parlayMinTicket) {
          this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.atLeastTwoMatchToBetParlay"), "info");
          this.loading.process = false;
          this.betConfirm = true;
          return;
        }
      }

      if (!validBet) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.matchHide"), "info");
        this.loading.process = false;
        this.betConfirm = true;
        return;
      }

      old = null;
      var cloneSlip = Object.assign({}, this.betparlay);
      var sumSlip = {};
      sumSlip.stake = this.stake.toString();
      sumSlip.payout = this.payout.toString();
      sumSlip.multi = this.multi.toString();
      xhrBet.betParlay(this.placeSlip).then(
        res => {
          // this.loading.process = false;
          if (res.success) {
            if (this.$store.state.layout.betting.defaultStake == "0") {
              this.$store.dispatch("layout/setSingleBetting", { property: "defaultStakeAmount", value: this.stake });
            }

            this.hideMe();

            if (EventBus.betParlayStatus) {
              EventBus.betParlayStatus(cloneSlip, sumSlip, res, this.total_bet);
            }

            if (EventBus.getBalance) {
              EventBus.getBalance();
            }
          } else {
            this.$helpers.handleFeedback(res.status);
          }
        },
        err => {
          this.loading.process = false;
          switch (err.status) {
            case "insufficient_balance":
              this.errorMessage = this.$t("error.insufficient_balance");
              break;
            case "atLeastThreeMatchToBetParlay":
              break;
            case "betLowerMin":
              this.errorMessage = this.$t("error.betLowerMin");
              break;
            case "betOverLimit":
              this.errorMessage = this.$t("error.betOverMaxBet");
              break;
            case "invalidOdds":
              this.invalidOdds = true;
              this.refreshOddsYes();
              break;
            case "oddsIsUpdating":
              this.oddsIsUpdating = true;
              clearTimeout(this.autoCloseOddsIsUpdating);
              this.autoCloseOddsIsUpdating = setTimeout(() => {
                this.oddsIsUpdating = false;
              }, this.defaultCounter * 1000);
              break;
            default:
              this.$helpers.handleFeedback(err.status);
              break;
          }
        }
      );
    },
    handlePayout() {
      var a = this.stake * this.multi;
      var b = this.maxBet * this.multi;
      if (a > b) {
        a = b;
      }
      this.payout = a.toFixed(3);
    },
    calculateStake() {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
      } else {
        if (parseInt(this.stake) > this.maxBet) {
          this.stake = this.maxBet;
        } else {
          if (parseInt(this.stake) < this.minBet) {
            this.stake = this.minBet;
          }
        }
      }
    },
    handleStake() {
      console.log(this.stake)
      if(this.stake % 1 != 0) {
        this.stake = Math.round(this.stake);
      }
      // if (this.stake == null || this.stake == undefined || this.stake == "") {
      // } else {
      //   if (parseInt(this.stake) > this.maxBet) {
      //     this.stake = this.maxBet;
      //   } else {
      //     if (parseInt(this.stake) < this.minBet) {
      //       this.stake = this.minBet;
      //     }
      //   }
      // }
      this.total_stake = this.stake * this.total_bet;
    },
    forceHandleStake() {
      if (parseInt(this.stake) > this.maxBet) {
        this.stake = this.maxBet;
      } else {
        if (parseInt(this.stake) < this.minBet) {
          this.stake = this.minBet;
        }
      }
      this.total_stake = this.stake * this.total_bet;
    },
    clearStake() {
      this.stake = "";
      $(".stake-cancel").hide();
      $(".stake-decrement").show();
      $(".stake-increment").show();
      // $(".keyboard").slideUp();
    },
    increaseStake() {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = this.minBet;
      }
      if (parseInt(this.stake) < this.maxBet) {
        if(parseInt(this.stake) * 2 > this.maxBet) {
          this.stake = this.maxBet;
        } else {
          this.stake = parseInt(this.stake) * 2;
        }
      }
      this.total_stake = this.stake * this.total_bet;
    },
    decreaseStake() {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = this.minBet;
      }
      if (parseInt(this.stake) > this.minBet) {
        if(parseInt(this.stake) / 2 < this.minBet) {
          this.stake = this.minBet;
        } else {
          this.stake = parseInt(this.stake) / 2;
        }
      }
      this.total_stake = this.stake * this.total_bet;
    },
    fastStake(amount) {
      if (this.stake == null || this.stake == undefined || this.stake == "") {
        this.stake = amount;
      } else {
        if (parseInt(this.stake) < this.maxBet) {
          if(parseInt(this.stake) + amount > this.maxBet) {
            this.stake = this.maxBet;
          } else {
            this.stake = parseInt(this.stake) + amount;
          }
        }
      }
      this.total_stake = this.stake * this.total_bet;
    },
    maxStake() {
      this.stake = this.maxBet;
      this.total_stake = this.stake * this.total_bet;
    },
    maskStake() {
      // console.log("maskStake");
      $(".keyboard").slideDown();
      $(".stake-decrement").hide();
      $(".stake-increment").hide();
      $(".stake-cancel").show();
      // $("#place-bet").hide();
    },
    keyStake(e) {
      // console.log(e);
      // this.$helpers.playTouchSound(e)
      this.stake = this.stake.toString() + e.toString();
      // this.handleStake();
      this.total_stake = this.stake * this.total_bet;
    },
    deleteStake() {
      var c = this.stake.toString();
      if (c.length > 0) {
        this.stake = c.slice(0, -1);
        this.handleStake();
      }
    },
    doneStake() {
      $(".keyboard").slideUp();
      $(".stake-cancel").hide();
      $(".stake-decrement").show();
      $(".stake-increment").show();
      $("#place-bet").show();
      // this.forceHandleStake();
    },
    checkMatchExists() {
      var result = true;
      if (this.betparlay != null) {
        var cache = this.cache();
        var otflag1 = false;
        var otflag2 = false;

        if (cache != null && cache.hasOwnProperty("match")) {
          for (var n in this.betparlay) {
            if (!cache.match.hasOwnProperty(this.betparlay[n].matchId)) {
              this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: "false" });
            } else {
              // check odds exist if match have more than 1 ot
              if (cache.match.hasOwnProperty(this.betparlay[n].matchId)) {
                if (cache.odds[1] != undefined) {
                  if (cache.odds[1]["hdp"] != undefined) {
                    if (cache.odds[1]["hdp"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["hdp"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["hdp"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["ou"] != undefined) {
                    if (cache.odds[1]["ou"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["ou"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["ou"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["oe"] != undefined) {
                    if (cache.odds[1]["oe"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["oe"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["oe"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["oxt"] != undefined) {
                    if (cache.odds[1]["oxt"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["oxt"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["oxt"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["ml"] != undefined) {
                    if (cache.odds[1]["ml"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["ml"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["ml"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[1]["orz"] != undefined) {
                    if (cache.odds[1]["orz"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[1]["orz"][this.betparlay[n].matchId]) {
                        if (cache.odds[1]["orz"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag1 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }
                }

                if (cache.odds[2] != undefined) {
                  if (cache.odds[2]["hdp"] != undefined) {
                    if (cache.odds[2]["hdp"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["hdp"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["hdp"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["ou"] != undefined) {
                    if (cache.odds[2]["ou"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["ou"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["ou"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["oe"] != undefined) {
                    if (cache.odds[2]["oe"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["oe"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["oe"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["oxt"] != undefined) {
                    if (cache.odds[2]["oxt"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["oxt"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["oxt"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["ml"] != undefined) {
                    if (cache.odds[2]["ml"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["ml"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["ml"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }

                  if (cache.odds[2]["orz"] != undefined) {
                    if (cache.odds[2]["orz"][this.betparlay[n].matchId]) {
                      for (var m in cache.odds[2]["orz"][this.betparlay[n].matchId]) {
                        if (cache.odds[2]["orz"][this.betparlay[n].matchId][m][3] == this.betparlay[n].oddsId) {
                          otflag2 = true;
                        }
                      }
                      this.$store.dispatch("betparlay/setSingleData", { matchid: this.betparlay[n].matchId, property: "betStatus", value: otflag1 });
                      if (otflag1) return result;
                    }
                  }
                }
              }
            }
          }
        } else {
          result = false;
        }
      }
      return result;
    },
    autoRefresh() {
      this.errorMessage = "";
      // var p = [];
      if (this.isDataExists) {
        if ((this.betting.autoRefreshOdds == true || this.betting.autoRefreshOdds == "true") && this.isDataExists) {
          // for (var n in this.betparlay) {
          //   p.push(this.requestSingleBet(this.betparlay[n], true));
          // }
          // Promise.all(p).then(() => {
          //   this.$store.dispatch("betparlay/setCombo").then(() => {});
          // });
          this.requestMultiBet(this.betparlay, true).then(() => {
            this.$store.dispatch("betparlay/setCombo").then(() => {});
          });
        }
      }
    },
    handleAutoRefresh() {
      this.$store.dispatch("layout/setSingleBetting", { property: "autoRefreshOdds", value: this.betting.autoRefreshOdds == "true" ? "false" : "true" });
      this.counter = this.defaultCounter;
    },
    handleAcceptAnyOdds() {
      this.$store.dispatch("layout/setSingleBetting", { property: "acceptAnyOdds", value: this.betting.acceptAnyOdds == "true" ? "false" : "true" });
    },
    refreshOddsYes() {
      this.invalidOdds = false;
      this.counter = this.defaultCounter;
      this.autoRefresh();
      // var p = [];
      // for (var n in this.betparlay) {
      //   p.push(this.requestSingleBet(this.betparlay[n]));
      // }
      // Promise.all(p).then(() => {
      //   this.$store.dispatch("betparlay/setCombo").then(() => {});
      // });
    },
    refreshOddsNo() {
      this.invalidOdds = false;
    },
    getBetLimit() {
      return this.$store.getters.playerBetLimit["PARLAY"];
    },
    cancelBetClick() {
      this.cancelBet();
      // setTimeout(() => {
      //   $("#collapse-allsports").collapse("show");
      // }, 100);
    },
    cancelBet() {
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
      this.loading.cancel = true;
      this.loading.check = false;
      this.league = {};
      this.match = {};
      this.counter = this.defaultCounter;
      this.$store.dispatch("betparlay/clearData").then(() => {
        this.loading.cancel = false;
        this.loading.process = false;
      });
    },
    checkParlayBet(odds, typ, idx, val, bt) {
      this.counter = this.defaultCounter;
      this.loading.check = true;
      var cache = this.cache();
      if (cache.hasOwnProperty("league") && cache.hasOwnProperty("match")) {
        var sd = {};

        sd.matchId = odds[1];
        sd.child = cache.child[sd.matchId];
        sd.parent = cache.parent[sd.matchId];

        if (sd.child != undefined) {
          for (var n in sd.child) {
            this.$store.dispatch("betparlay/removeData", sd.child[n][0]).then(() => {});
          }
        }

        if (sd.parent != undefined) {
          this.$store.dispatch("betparlay/removeData", sd.parent).then(() => {});
        }

        sd.typ = typ;
        sd.idx = idx;
        sd.val = val;

        sd.leagueId = odds[0];
        sd.subMatchId = odds[2];
        sd.oddsId = odds[3];
        sd.betType = odds[4];
        sd.target = bt;

        this.league = cache.league[sd.leagueId];
        this.match = cache.match[sd.matchId];

        sd.sportsType = this.league[1];
        sd.leagueId = this.league[0];
        sd.leagueName = this.league[4];

        var limit = this.getBetLimit();
        sd.minBet = limit.min_bet;
        sd.maxBet = limit.max_bet;
        sd.maxPayout = limit.max_payout;
        sd.maxParlayPayout = 0;
        sd.marketType = this.match[4];
        sd.homeName = this.match[5];
        sd.awayName = this.match[6];
        sd.workingDate = this.match[7];
        sd.matchTime = this.match[8];
        sd.homeId = this.match[22];
        sd.awayId = this.match[23];
        sd.score = this.match[11] ? this.match[11].toString().trim() : "";
        sd.awayId = this.match[23];
        sd.typId = config.oddsTypeId[sd.typ];
        sd.ballDisplay = "";
        sd.betDisplay = "";

        this.setBetType(sd, odds);
        this.requestSingleBet(sd, false).then(() => {
          this.$store.dispatch("betparlay/setCombo").then(() => {
            this.changeTotalBet();
          });
        });

        this.league = null;
        this.match = null;
      }
    },
    processMultiBet(multi, results, refresh) {
      // var m = Object.assign({}, multi);
      let m = JSON.parse(JSON.stringify(multi));

      for (var n in m) {
        var sd = m[n];
        var res = results[n];
        var d = res.odds_check_details[0];
        var success = false;
        if (typeof res.status == "string") {
          success = res.status == "1";
        } else {
          success = res.status == 1;
        }
        if (success) {
          if(sd.oddsId == d.odds_id) {
            sd.oddsChanged = d.odds_change;
            sd.ballChanged = d.ball_change;
            if (d.home_giving == true) {
              sd.giving = 1;
            } else {
              sd.giving = 0;
            }
            if (d.ball_display_new != null) {
              sd.ballChangedText = this.getBallDisplay(sd.ballDisplay.toString(), sd.giving, sd.homeAway, sd.betType);
              sd.ballDisplay = d.ball_display_new;
            }
            if (d.odds_display_new != null) {
              sd.oddsChangedText = sd.val;
              sd.val = calc.fmtType(d.odds_display_new, this.commType, sd.betType);
            }
            if (d.odds_new != null) {
              sd.origin = calc.fmt(d.odds_new);
            }
            if (sd.minBet < d.min_bet) {
              sd.minBet = d.min_bet;
            }
            if (sd.maxBet > d.max_bet) {
              sd.maxBet = d.max_bet;
            }
            sd.maxParlayPayout = d.max_parlay_payout;
            var flag = 1;
            if (!refresh) {
              Object.keys(this.parlayMatch).forEach(
                function(i) {
                  if (i == sd.matchId) {
                    flag = 0;
                    sd.bettime = this.parlayMatch[sd.matchId];
                  }

                  if (i == sd.matchId && this.parlayMatch[sd.matchId] == 0) {
                    flag = 1;
                  }
                }.bind(this)
              );

              if (flag) {
                sd.bettime = new Date().getTime();
                this.parlayMatch[sd.matchId] = sd.bettime;
              }
            }
            sd.betStatus = true;
            if (sd.typ != "DEC") {
              sd.multi = parseFloat(sd.val).toFixed(4);
            }
            this.$store.dispatch("betparlay/setData", sd).then(() => {});
            // console.log(sd, d);
          }
        }
      }
    },
    requestMultiBet(multi, refresh) {
      return new Promise((resolve, reject) => {
        var parlay = [];
        for (var n in multi) {
          var data = multi[n];
          if (data == null) {
            this.cancelBet("requestMultiBetNoData");
            return;
          }
          if (!data.betType || !data.oddsId || !data.sportsType) {
            this.cancelBet("requestMultiBetInvalid");
            return;
          }
          var item = {
            sports_type: data.sportsType,
            parlay: data.target == "parlay",
            odds_id: data.oddsId,
            submatch_id: data.subMatchId,
            bet_type: data.betType,
            bet_team_id: data.betTeamId,
            home_away: data.homeAway,
            odds_display: parseFloat(data.val),
            odds_mo: parseFloat(data.origin),
            odds_type: data.typId,
            ball_display: data.ballDisplay
          };
          parlay.push(item);
        }

        var slip = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          parlay: parlay
        };

        var cache = this.cache();
        xhrBet.betMultiOddsCheck(slip).then(
          res => {
            // console.log(res);
            if (res.success) {
              if (multi != null) {
                this.processMultiBet(multi, res.data, refresh);
                this.loading.check = false;
                this.invalidOdds = false;
              }
            } else {
              this.$helpers.handleFeedback(res.status);
            }

            resolve();
          },
          err => {
            this.$helpers.handleFeedback(err.status);
            resolve();
          }
        );
      });
    },
    requestSingleBet(data, refresh) {
      return new Promise((resolve, reject) => {
        if (data == null) {
          this.cancelBet("requestSingleBetNoData");
          return;
        }
        if (!data.betType || !data.oddsId || !data.sportsType) {
          this.cancelBet("requestSingleBetInvalid");
          return;
        }

        var slip = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          sports_type: data.sportsType,
          parlay: data.target == "parlay",
          odds_id: data.oddsId,
          submatch_id: data.subMatchId,
          bet_type: data.betType,
          bet_team_id: data.betTeamId,
          home_away: data.homeAway,
          odds_display: parseFloat(data.val),
          odds_mo: parseFloat(data.origin),
          odds_type: data.typId,
          ball_display: data.ballDisplay
        };
        var cache = this.cache();
        xhrBet.betSingleOddsCheck(slip).then(
          res => {
            if (res.success) {
              if (data != null) {
                var sd = Object.assign({}, data);
                sd.oddsChanged = res.data[0].odds_change;
                sd.ballChanged = res.data[0].ball_change;
                if (res.data[0].home_giving == true) {
                  sd.giving = 1;
                } else {
                  sd.giving = 0;
                }
                if (res.data[0].ball_display_new != null) {
                  sd.ballChangedText = this.getBallDisplay(sd.ballDisplay, sd.giving, sd.homeAway, sd.betType);
                  sd.ballDisplay = res.data[0].ball_display_new;
                }
                if (res.data[0].odds_display_new != null) {
                  sd.oddsChangedText = sd.val;
                  sd.val = calc.fmtType(res.data[0].odds_display_new, this.commType, sd.betType);
                }
                if (res.data[0].odds_new != null) {
                  sd.origin = calc.fmt(res.data[0].odds_new);
                }

                if (sd.minBet < res.data[0].min_bet) {
                  sd.minBet = res.data[0].min_bet;
                }
                if (sd.maxBet > res.data[0].max_bet) {
                  sd.maxBet = res.data[0].max_bet;
                }
                sd.maxParlayPayout = res.data[0].max_parlay_payout;
                var flag = 1;
                if (!refresh) {
                  Object.keys(this.parlayMatch).forEach(
                    function(i) {
                      if (i == sd.matchId) {
                        flag = 0;
                        sd.bettime = this.parlayMatch[sd.matchId];
                      }

                      if (i == sd.matchId && this.parlayMatch[sd.matchId] == 0) {
                        flag = 1;
                      }
                    }.bind(this)
                  );

                  if (flag) {
                    sd.bettime = new Date().getTime();
                    this.parlayMatch[sd.matchId] = sd.bettime;
                  }
                }
                sd.betStatus = true;
                if (sd.typ != "DEC") {
                  sd.multi = parseFloat(sd.val).toFixed(4);
                }
                this.$store.dispatch("betparlay/setData", sd);
                this.loading.check = false;
                this.invalidOdds = false;
              }
            } else {
              this.$helpers.handleFeedback(res.status);
            }

            resolve();
          },
          err => {
            this.$helpers.handleFeedback(err.status);
            resolve();
          }
        );
      });
    },
    addPick(e, t, amt) {
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
      this.showMe();

      var cnt = 1;

      this.stake = amt;

      // this.calculateStake();
      // this.handleStake();

      var nonExistList = [];
      for (var i = 0; i < e.length; i++) {
        var x = e[i];
        // replace the existing betslip
        if (this.existsInSlip(x.match_id.toString())) {
          this.checkPick(x, t, amt, true, cnt++).then(() => {});
        } else {
          nonExistList.push(x);
        }
      }

      // check if got free space to add
      var total = Object.keys(this.$store.state.betparlay.data).length;
      var validTotal = config.parlayMaxTicket - total;
      if (nonExistList.length < validTotal) {
        validTotal = nonExistList.length;
      }
      // console.log(total, nonExistList.length, validTotal, total + validTotal);
      if (total >= config.parlayMaxTicket) {
        this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
        return;
      } else {
        if (total + validTotal > config.parlayMaxTicket) {
          this.$helpers.showDialog(this.$t("ui.action"), this.$t("error.maxParlayTicket"), "info");
          return;
        }
      }
      // add those valid betslip
      for (var i = 0; i < validTotal; i++) {
        this.checkPick(nonExistList[i], t, amt, false, cnt++).then(() => {});
      }

      setTimeout(() => {
        this.calculateStake();
        this.handleStake();
      }, cnt * 100);

      if (this.$refs.stake) {
        this.$refs.stake.focus();
      }
      clearTimeout(this.autoCloseOddsIsUpdating);
      this.invalidOdds = false;
      this.oddsIsUpdating = false;
    },

    checkPick(odds, typ, amt, blink, cnt) {
      return new Promise(resolve =>
        setTimeout(() => {
          this.counter = this.defaultCounter;

          var sd = {};

          sd.matchId = odds.match_id;

          sd.typ = typ;
          sd.pick = odds.target;
          sd.idx = odds.pick_idx;
          sd.val = odds.pick_odds;

          sd.leagueId = odds.league_id;
          sd.subMatchId = odds.submatch_id;
          sd.oddsId = odds.odds_id;
          sd.target = "parlay";

          sd.sportsType = odds.sports_type;
          sd.leagueName = odds.league_name_en;

          var limit = this.getBetLimit();
          sd.minBet = limit.min_bet;
          sd.maxBet = limit.max_bet;
          sd.maxPayout = limit.max_payout;
          sd.maxParlayPayout = 0;
          sd.marketType = odds.market_type;
          sd.workingDate = odds.working_date;
          sd.matchTime = odds.match_time;
          sd.score = odds.home_running_score == null ? "" : odds.home_running_score + " - " + odds.away_running_score;
          sd.typId = config.oddsTypeId[sd.typ];

          sd.betType = odds.betType;
          sd.homeId = odds.homeId;
          sd.awayId = odds.awayId;
          sd.homeName = odds.homeName;
          sd.awayName = odds.awayName;

          sd.giving = odds.giving;
          sd.parlay = odds.parlay;
          sd.ballDisplay = odds.ballDisplay;

          sd.betTeamId = odds.betTeamId;
          sd.betTeamName = odds.betTeamName;
          sd.betDisplay = odds.betDisplay;

          sd.origin = odds.origin;
          sd.homeAway = odds.homeAway;

          this.requestSingleBet(sd, false).then(() => {
            if (blink) {
              var elem = document.getElementById("betslip-parlay-" + sd.matchId);
              if (elem) {
                if (elem.classList.contains("blink3")) {
                  elem.classList.remove("blink3");
                }
                elem.classList.add("blink3");
              }
            }
            this.$store.dispatch("betparlay/setCombo").then(() => {
              this.changeTotalBet();
            });
          });
        }, cnt * 50)
      );
    }
  }
};
</script>
